<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-spectrum/view';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '../package.json';

```jsx import
import {Header} from '@react-spectrum/view';
```

---
category: Content
---

# Header

<p>{docs.exports.Header.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['Header']} />

## Examples

```tsx example
<Header>Terms and Conditions</Header>
```

## Content

The Header component is used as a child to other components. Based on the
component it is used within, it gets Spectrum styling and may have a preassigned
slot for positioning. By virtue of its name, the Header component provides
semantic meaning in the context they are placed. An example of this is
explained in [Dialog](Dialog.html#content). It is important to note that the
Header element accepts any renderable node, not just strings.

A Header is used to specify a layout region providing supplemental title information above the
content section of a component. Example usage can be found in [Dialog](Dialog.html#example).

See [the MDN docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/header) for more information.

## Props

<PropTable component={docs.exports.Header} links={docs.links} />
